export const shelfTagValidationProperties = {
    DELIMITER: ' ',
    REGEX: /^[\w]{10}\s[\d]+(\.[\d]+)?$/,
};

export class ShelfTagService {
    public static isValid(asinPrice) {
        asinPrice = asinPrice || '';
        asinPrice = asinPrice.trim();
        return shelfTagValidationProperties.REGEX.test(asinPrice);
    }

    public static getAsin(asinPrice, validate?) {
        asinPrice = asinPrice || '';
        // Default to empty string if the asinPrice is null or undefined.
        if (!validate || ShelfTagService.isValid(asinPrice)) {
            return asinPrice.trim().split(shelfTagValidationProperties.DELIMITER)[0];
        }
        return null;
    }
}
